function clone(obj: any): any {
  let result = obj
  const type = {}.toString.call(obj).slice(8, -1)
  if (type === 'Set') {
    return new Set([...obj].map((value) => clone(value)))
  }
  if (type === 'Map') {
    return new Map([...obj].map((kv) => [clone(kv[0]), clone(kv[1])]))
  }
  if (type === 'Date') {
    return new Date(obj.getTime())
  }
  if (type === 'RegExp') {
    return RegExp(obj.source, getRegExpFlags(obj))
  }
  if (type === 'Array' || type === 'Object') {
    result = Array.isArray(obj) ? [] : {}
    // biome-ignore lint/nursery/useGuardForIn: For cloning we want to include
    for (const key in obj) {
      // include prototype properties
      result[key] = clone(obj[key])
    }
  }
  // primitives and non-supported objects (e.g. functions) land here
  return result
}

function getRegExpFlags(regExp: any) {
  if (typeof regExp.source.flags === 'string') {
    return regExp.source.flags
  }
  const flags: string[] = []
  regExp.global && flags.push('g')
  regExp.ignoreCase && flags.push('i')
  regExp.multiline && flags.push('m')
  regExp.sticky && flags.push('y')
  regExp.unicode && flags.push('u')
  return flags.join('')
}

/** Deep copy an object */
export function deepClone<T>(data: T): T {
  // Wrap just-clone for possible substitution
  return typeof data === 'object' && data !== null ? (clone(data) as any) : data
}
